import { productRepository } from 'repositories/ProductsRepository';
import { isOk } from 'domains/Result';

import { Currency, IBoostModalData, ISuggestedProductModal } from 'types';

import { fireToast } from 'helpers/Toasts';
import { IncomingHttpHeaders } from 'http';

interface IUseBoostHandler {
  userId: string;
  adId: number;
  setBoostModalData: (t: IBoostModalData | undefined) => void;
  setIsBoostModalOpen: (t: boolean) => void;
  currency: Currency;
  photoCount: number;
  sectionId: number;
  wanted: boolean;
  price: string;
  section?: string;
  contentShare?: {
    setClickedAdId: (t: number | undefined) => void;
    setCurrency: (t: Currency | undefined) => void;
    setSuggestedProductModalData: (
      t: ISuggestedProductModal | undefined,
    ) => void;
    suggestedProductModal?: ISuggestedProductModal;
  };
}

async function UseBoostHandler(
  {
    userId,
    adId,
    setBoostModalData,
    setIsBoostModalOpen,
    currency,
    photoCount,
    sectionId,
    wanted,
    price,
    section,
    contentShare,
  }: IUseBoostHandler,
  headers: IncomingHttpHeaders,
) {
  const upsells = await productRepository.getUpsells(
    userId,
    adId,
    currency,
    sectionId,
    photoCount,
    wanted,
    price,
    headers,
  );
  if (isOk(upsells)) {
    setBoostModalData({
      ...upsells.ok,
      section,
    });
    setIsBoostModalOpen(true);

    if (contentShare) {
      contentShare.setCurrency(currency);
      contentShare.setClickedAdId(adId);
      contentShare.setSuggestedProductModalData(
        contentShare.suggestedProductModal,
      );
    }
  } else {
    fireToast({
      type: 'ERROR',
      text: 'Oops! Something went wrong, please try again later',
    });
  }
}

export { UseBoostHandler };
